import { ContentfulIncludes } from "frontend/contentful/schema/sys";

// This is a temporary solution to determine if the page needs the program comparison context & tray.
// It is currently needed for ExEd pages, and will be needed for HBS Online pages in the future.
// Consider a refactor to expose global site-specific context/state in a more structured way.
export const checkNeedsProgramComparison = (includes: ContentfulIncludes) => {
  return includes.Entry?.some((i) => {
    return (
      i.sys.contentType.sys.id === "teaseRowProgramCards" ||
      i.sys.contentType.sys.id === "teaseRowCourseCards" ||
      false
    );
  });
};
